import { getDifference } from '@vitvio/helpers';
import type { DemoEventAlert } from './demo-event-interface';

export const demoNotification1: DemoEventAlert = {
  displayMessage: 'OR Manager notification',
  template: 'anaesthetic_start_time',
  generateParameters: (event, operatingRoomName, lastSurgicalEvent) => {
    return [operatingRoomName, event.timestamp, lastSurgicalEvent?.timestamp || ''];
  },
};

export const demoNotification2: DemoEventAlert = {
  displayMessage: 'OR Manager notification',
  template: 'demo_knife_to_skin',
  generateParameters: (event, operatingRoomName) => {
    return [event.timestamp, operatingRoomName];
  },
};

export const demoNotification3: DemoEventAlert = {
  displayMessage: 'Pre-Op Ward to send the next patient',
  template: 'demo_skin_closure',
  generateParameters: (event, operatingRoomName, lastSurgicalEvent, lastEvent) => {
    const timeDifference = getDifference(
      new Date(`2024-10-10:${event?.timestamp}`),
      new Date(`2024-10-10:${lastEvent?.timestamp}`),
      'minutes',
    );

    return [
      operatingRoomName,
      event.timestamp,
      lastSurgicalEvent?.timestamp || '',
      operatingRoomName,
      String(timeDifference),
    ];
  },
};

export const demoNotification4: DemoEventAlert = {
  displayMessage: 'Cleaning Crew notification',
  template: 'demo_ready_to_transfer_to_recovery',
  generateParameters: (_event, operatingRoomName) => {
    return [operatingRoomName];
  },
};

export const demoNotification5: DemoEventAlert = {
  displayMessage: 'Room Ready notification',
  template: 'demo_or_is_ready',
  generateParameters: (_event, operatingRoomName) => {
    return [operatingRoomName];
  },
};
